<script> 
	import { 
		headerTitleHome, 
		linkAV,
		linkConheca,
		linkSolicite,
		linkPesquisaVendas,
		linkPesquisaLocacao,
		linkInstagram,
	} from '../store.js';
	
	import { link }         		from "svelte-routing";
	import { onMount, onDestroy  }	from 'svelte';
	import Instagram				from '../components/Instagram.svelte'

	import Boleto           		from '../components/Boleto.svelte'
	import WhatsGeral          		from '../components/Whatsapp.svelte'
	import PopUp					from '../components/PopUp.svelte'
	import Forms					from "../components/Forms.svelte";  
	import Lettering				from '../components/Lettering.svelte'
	import Busca					from '../components/Busca.svelte'	
	import ListaImoveis from './../components/ListaImoveis.svelte'
    import Whatsapp from '../components/Whatsapp.svelte';

	let vitrines = [
		{
			icon: 'fal fa-city',
			title: 'Administração de Condomínios',
			text: 'Com tranquilidade e segurança, conheça os benefícios.',
			href: '/administracao-condominios'
		},
		{
			icon: 'fal fa-key',
			title: 'Aluguel de Imóveis',
			text: 'Sem complicação e com a orientação dos nossos especialistas.',
			href: '/imoveis/locacao#tipo_negociacao=2&cidade=Porto%20Alegre&valor_de=0&valor_ate=0&valor_completo=0'
		},
		{
			icon: 'fal fa-handshake',
			title: 'Venda de Imóveis',
			text: 'Oportunidades selecionadas e apoio total na negociação.',
			href: '/imoveis/vendas#tipo_negociacao=1&cidade=Porto%20Alegre'
		},
		{
			icon: 'fal fa-shield-check',
			title: 'Soluções em Seguros',
			text: 'Proteja o patrimônio com ampla cobertura e custo reduzido.',
			href: '#seguros'
		},
	];
	
	function toggleMenu() {
		document.querySelector('header.header--hidden').classList.toggle('hidden');
	}

	function search(e) {
		const url = '/imoveis/' + (e.detail.tipo_negociacao == atria.rent?'locacao':'vendas') + '#' + Object.entries(e.detail).filter(p=>p[1].toString().length>0&&p[1].toString()!='0').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}	

	let fields = [
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required',
			rowclass: 'flex-1'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone',
			rowclass: 'flex-1'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email',
			rowclass: 'flex-1'
		},
		{
			title:      'Você é síndico?',
			name:       'eh-sindico',
			type:       'select',
			rowclass: 'flex-1',
			selectValues: [
				{
					title: 'Você é síndico?',
					value: ''
				},
				{
					title: 'Sim',
					value: 'Sim'
				},
				{
					title: 'Não',
					value: 'Não'
				}
			]
		},          
		{
			title:      'Nome do condomínio *',
			name:       'condominio-nome',
			required:   'required',
			rowclass: 'flex-1'
		}
	];
	
	const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Você é síndico?: {eh-sindico}
Nome do condomínio: {condominio-nome}

{info}`;

	let loading = false;
	function send() {
		loading = true;
	}

	/* Imóveis */ 		
	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1, destaque: true};
	let filtrosDestaquesVendas = {nt:atria.sell, tipo_negociacao:atria.sell, pageSize:6, random: 1, destaque: true};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao');
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas');
		}
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 3,
				autoplay: true,
				arrows: true,
				dots: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false,
						}
					}
				]
			});
		}, 500);
	}

	function loadHero() {
		document.querySelector('.show-home').style.display='';
		jQuery('section.hero .imgs .carousel').slick({
			speed: 400,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			arrows: false,
			dots: false
		});
	}

	//Esconde cabecalho
	onMount(async () => {
		document.querySelector('body').classList.add('site--home');
		loadHero();
	});
	onDestroy(async () => {
		document.querySelector('body').classList.remove('site--home');
		document.querySelector('header').classList.remove('hidden');
	});
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<section class="section hero">
	<div class="barra"></div>
	<div class="container container-short">
		<div class="imgs">
			<div class="carousel">
				<img src="assets/images/vitrines/vitrineTopo01.jpg" aria-hidden="true" alt="" />
				<img src="assets/images/vitrines/vitrineTopo02.jpg" aria-hidden="true" alt="" />
				<img src="assets/images/vitrines/vitrineTopo03.jpg" aria-hidden="true" alt="" />
			</div>
		</div>
		<div class="header header-left">
			<Lettering />
			<p>Experiência e inovação em gestão imobiliária,<br class="hidden-sm hidden-xs" /> conte com nossos serviços especializados.</p>
		</div>
		<div class="items">
			{#each vitrines as vitrine}
				{#if vitrine.blank}
				<div class="blank"></div>
				{:else}
				<a class="item" href={vitrine.href}>
					<div class="icon">
						<i class="{vitrine.icon}"></i>
					</div>
					<h4>{vitrine.title}</h4>
					<p>{vitrine.text}</p>
				</a>
				{/if}
			{/each}
		</div>
	</div>	
</section>

<section class="busca section info" style="padding: 40px 0px;">
	<a name="busca"></a>
	<div class="busca container">	
		<div class="header" style="padding-bottom: 0px">
			<h2 class="header" style="font-size: 32px">Encontre aqui o imóvel que você procura</h2>
		</div>
		<Busca on:filter={search} style='home' buttonClass='btn-tertiary' />
	</div>
</section>

<!-- Destaques Alugar -->
<section class="section destaques-home destaques-home--locacao info">
	<div class="container">
		<div class="header pt-40 pb-20">
			<h2 class="header">
				<a href="{$linkPesquisaLocacao}">Alugue seu imóvel</a> com a Bona Imóveis
			</h2>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
	</div>
</section>

<section class="section about">
	<div class="container container-short">
		<div class="holder">
			<div class="left">
				<iframe src="https://www.youtube.com/embed/J20k1Io0Nn4?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
			<div class="right">
				<div class="content">
					<img src="assets/images/simboloB_2.png" aria-hidden="true" alt="" />
					<h3 class="mt-20 mb-20">Referência em<br class="hidden-sm hidden-xs" /> administração de<br class="hidden-sm hidden-xs" /> condomínios, locação e<br class="hidden-sm hidden-xs" /> vendas em Porto Alegre,<br class="hidden-sm hidden-xs" /> desde 1991.</h3>
					<a href="/sobre" class="btn btn-secondary">CONHEÇA A BONA IMÓVEIS</a>
				</div>
			</div>
		</div>
	</div>
</section>

<!--Links-->
<section class="section links">
	<div class="container container-short">
		<div class="items grid grid-size--3 grid-size-sm--1">
			<div class="item flex-1 flex flex-column">
				<div class="icon">
					<i class="fal fa-building"></i>
				</div>
				<h4>Para o seu condomínio</h4>
				<p>Soluções em administração condominial promovendo assistência total no dia a dia do seu condomínio.</p>
			</div>
			<div class="item flex-1 flex flex-column">
				<div class="icon">
					<i class="fal fa-wallet"></i>
				</div>
				<h4>Para o seu patrimônio</h4>
				<p>Venda ou alugue o seu imóvel com todo o apoio profissional para uma negociação excelente e segura.</p>
			</div>
			<div class="item flex-1 flex flex-column">
				<div class="icon">
					<i class="fal fa-key"></i>
				</div>
				<h4>Para o seu lugar</h4>
				<p>Compre ou alugue o lugar ideal para você, contando com nossos especialistas, ofertas selecionadas e orientação constante.</p>
			</div>
		</div>
	</div>
</section>

<section class="section info darkgreen admcondominio">
	<a name="admcondominio"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/imgAdministracao.jpg')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="box flex flex-column flex-center flex-center">
					<h2 class="header inline">Administração<br class="hidden-sm hidden-xs" /> de condomínio</h2>
					<p>Seu condomínio administrado por quem entende<br class="hidden-sm hidden-xs" /> do assunto, confira os benefícios.</p>
					<div class="flex flex-center flex-wrap gap-10">
						<a href="/administracao-condominios" target="_blank" class="btn btn-secondary">SAIBA MAIS</a>
						<a href="/solicite-proposta" target="_blank" class="btn btn-secondary">SOLICITE UMA PROPOSTA</a>
					</div>
				</div>
			</div>
			<div class="image flex-1 right hidden-sm hidden-xs" style="background-image: url('assets/images/imgAdministracao.jpg')"></div>
		</div>
	</div>
</section>

<section class="section info sindicoprof">
	<a name="sindicoprof"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/imgSindico.jpg')"></div>
			<div class="image flex-1 left hidden-sm hidden-xs" style="background-image: url('assets/images/imgSindico.jpg')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="box flex flex-column flex-center">
					<h2 class="header inline">Prestação de<br class="hidden-sm hidden-xs" /> contas digital</h2>
					<p>Informações financeiras disponíveis no aplicativo<br class="hidden-sm hidden-xs" /> 24 horas por dia.</p>
					<a href="{$linkConheca}" target="_blank" class="btn btn-secondary">CONHEÇA</a>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section info gray solucoes">
	<a name="seguros"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/imgSeguros.jpg')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="box flex flex-column flex-center">
					<h2 class="header inline">Soluções<br class="hidden-sm hidden-xs" /> em seguros</h2>
					<p>Mais proteção para sua casa ou o seu negócio,<br class="hidden-sm hidden-xs" /> conheça as opções disponíveis.</p>
					<div class="flex flex-center flex-wrap gap-10">
						<a href="/seguroresidencial" target="_blank" class="btn btn-secondary">RESIDENCIAL</a>
						<a href="/segurocomercial" target="_blank" class="btn btn-secondary">COMERCIAL</a>
					</div>
				</div>
			</div>
			<div class="image flex-1 right hidden-sm hidden-xs" style="background-image: url('assets/images/imgSeguros.jpg')"></div>
		</div>
	</div>
</section>

<section class="section proposta">
	<div class="container container-short">
		<div class="header">
			<h2 class="header">Solicite uma proposta sem compromisso</h2>
			<p>E conheça os benefícios das nossas soluções para o seu condomínio.</p>
		</div>
		<div class="box box-green">
			<div class="content">
				<Forms destiny={''} fields={fields} formclass='formulario-horizontal' {message} buttonText="SOLICITAR PROPOSTA" buttonClass="btn btn-secondary" htmlbody={false} />
			</div>
		</div>
	</div>
</section>

<section class="section info cartaosindico">
	<a name="cartaosindico"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/imgCartao_2.png')"></div>
			<div class="image flex-1 left hidden-sm hidden-xs" style="background-image: url('assets/images/imgCartao_2.png')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="box flex flex-column flex-center">
					<h2 class="header inline">Cartão<br class="hidden-sm hidden-xs" /> do síndico</h2>
					<p>Para facilitar a operação e organizar o<br class="hidden-sm hidden-xs" /> controle financeiro do seu condomínio.</p>
					<a href="/cartao-do-sindico" class="btn btn-secondary">CONHEÇA A SOLUÇÃO</a>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section info cartaosindico">
	<a name="aplicativo"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/imgMockup_2.png')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="box flex flex-column flex-center">
					<h2 class="header inline">Aplicativo Bona<br class="hidden-sm hidden-xs" /> Imóveis Digital</h2>
					<p>Utilize no seu smartphone, tablet ou computador,<br class="hidden-sm hidden-xs" /> todos os serviços em um único lugar.</p>
					<a href="{$linkAV}" target="_blank" class="btn btn-secondary">ACESSE AGORA</a>
				</div>
			</div>
			<div class="image flex-1 right hidden-sm hidden-xs" style="background-image: url('assets/images/imgMockup_2.png')"></div>
		</div>
	</div>
</section>

<section class="section info oferta darkgreen">
	<a name="imoveis"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/imgImoveis.jpg')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="box flex flex-column flex-center">
					<h2 class="header inline">Imóveis em Oferta,<br class="hidden-sm hidden-xs" /> Vídeos e Tour Virtual</h2>
					<p style="width:100%">Visite o imóvel para alugar ou comprar sem sair de casa,<br class="hidden-sm hidden-xs" /> ou acesse o nosso catálogo completo de ofertas.</p>
					<div class="flex flex-center flex-wrap gap-10">
						<a href="/imoveis/locacao#nt=2&tipo_negociacao=2" class="btn btn-secondary">PARA ALUGAR</a>
						<a href="/imoveis/vendas#tipo_negociacao=1&cidade=Porto%20Alegre" class="btn btn-secondary">PARA COMPRAR</a>
						<a href="/imoveis/locacao#tipo_negociacao=2&cidade=Porto%20Alegre&valor_de=0&valor_ate=0&valor_completo=1&recursos=$VIDEO$" class="btn btn-secondary">COM VÍDEO</a>
						<a href="/imoveis/locacao#tipo_negociacao=2&cidade=Porto%20Alegre&valor_de=0&valor_ate=0&valor_completo=1&recursos=$TOUR$" class="btn btn-secondary">COM TOUR VIRTUAL</a>
					</div>
				</div>
			</div>
			<div class="image flex-1 right hidden-sm hidden-xs" style="background-image: url('assets/images/imgImoveis.jpg')"></div>
		</div>
	</div>
</section>

<section class="section ajuda">
	<div class="container container-short">
		<div class="header">
			<h2 class="header">Como podemos ajudar?</h2>
			<p>Selecione o que você procura, estamos prontos para auxiliar.</p>
		</div>
		<div class="links">
			<a class="link" href="/anuncie">
				<i class="fal fa-laptop-house"></i>
				<p>ANUNCIAR MEU IMÓVEL</p>
			</a>
			<a class="link" href="/documentacao-necessaria">
				<i class="fal fa-file-signature"></i>
				<p>COMO ALUGAR?</p>
			</a>
			<a class="link" href="{$linkAV}" target="_blank">
				<i class="fal fa-barcode-alt"></i>
				<p>BOLETOS E FINANCEIRO</p>
			</a>
			<a class="link" href="{$linkSolicite}" target="_blank">
				<i class="fal fa-lock-alt"></i>
				<p>SOLICITAR SENHA</p>
			</a>
		</div>
	</div>
</section>

<section class="section info gray instagram">
	<div class="container container-short">
		<div class="header">
			<h2 class="header simple"><a href={$linkInstagram} target="_blank">@bona_imoveis</a> nas Redes Sociais</h2>
		</div>
	</div>
	<Instagram />
</section>

<Boleto />
<Whatsapp />
<PopUp channel="site" />